/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_CharactersInputs */



/**
* | output |
* | --- |
* | "Text-to-Speech Characters" |
*
* @param {Tts_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tts_characters = /** @type {((inputs?: Tts_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractères synthèse vocale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text-to-Speech-Zeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri di sintesi vocale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Символы, преобразуемые в речь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres de texto a voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转语音字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声合成文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट-टू-स्पीच कैरेक्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caracteres de texto para fala")
	return /** @type {LocalizedString} */ ("Text-to-Speech Characters")
});